import { useCallback } from "react"

import { httpsCallable } from "firebase/functions"
import { useForm } from "@mantine/form"

import { useLanguage } from "../../../../contexts/language-context"
import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { firebase } from "../../../../services/firebase/firebase"
import { DeviceDocument } from "../../../../contexts/devices-context"
import { AwsIotChangeGroupData } from "../../../../functions/aws/iot/aws-iot-changeGroup"

export default (device: DeviceDocument, onClose: () => void) => {
    const { L } = useLanguage()
    const form = useForm({
        initialValues: { targetGroup: null as string | null },
        validate: { targetGroup: value => (!value ? L("A group must be selected") : null) },
    })
    const { onStart, onSuccess, onError, processing } = useCloudFunction("aws-iot-changeGroup")

    const onSubmit = useCallback(
        (values: typeof form.values) => {
            onStart(L("Moving device from %s to %s", device.group, values.targetGroup!))
            httpsCallable<AwsIotChangeGroupData>(
                firebase.functions,
                "aws-iot-changeGroup",
            )({
                id: device.id,
                ...(device.group && { originGroup: device.group }),
                targetGroup: values.targetGroup!,
                organisation: device.organisation,
            })
                .then(onSuccess())
                .then(onClose)
                .catch(onError())
        },
        [L, device, form],
    )

    return { form, onSubmit, processing }
}
